export default {
  /*按钮*/
  bt:{
    search:"搜索",
    query:"查询",
    operation:"操作",
    add:"新增",
    edit:"修改",
    delete:"删除",
    down:"下载",
    export:"导出",
    upload:"上传"
  },
  accountDataTable:{
    updateTime: '更新时间:',
    sumAccountReal:'新增真实账户数',
    sumAccountDemo:'新增模拟账户数',
    sumDayAccountReal:'日均真实账户数',
    sumDayAccountDemo:'日均模拟账户数',
    day:"天",
    weekBy:'周',
    monthBy:'月',
    detail:'明细数据',
    export:'导出',
    date:'日期',
    realCount:'真实账号数',
    demoCount:'模拟账号数',
    time:'开户时间',
    advertisingChannel:'渠道来源',
    advertisingSeries:'系列来源',
    advertisingMj:'媒介来源',
  },
  activateDataTable:{
    addActivate:'新增激活账户数',
    dayActivate:'当日激活账户数',
    avgActivate:'日均激活账户数',
    avgDayActivate:'日均当日激活账户数',
    ratio:'当日激活占比',
    activateCount:'激活账户',
    dayActivateCount:'当日激活账户',
    oldAccount:'老账户激活数',
    newThan:'当日激活账户占比',
    oldThan:'老账户激活占比',
    time:'激活时间',
  },
  depositTable:{
    depositAccount:'存款账户数',
    depositCount:'存款次数',
    againDepositionAccount:'复存账户数',
    depositAmount:'存款金额（美元）',
    avgDeposit:'人均存款次数',
    avgDepositAmount:'人均存款金额（美元）',
    amountAccount:'存款账户数',
    amountCount:'存款次数',
    afterDeposit:'复存账户数',
    time:'存款时间',
    inChannel:'全部平台',
    payWay:'全部支付方式',
  },
  depositMoneyTable:{
    amountMoney:'存款金额',
    amountAccountCount:'存款账户数',
    amountCount:'存款次数',
  },
  poorTable:{
    withdrawalAccount:'取款账户数',
    withdrawalAmount:'取款金额（美元）',
    poorAmount:'充提差',
    time:'取款时间'
  },
  withdrawalTable:{
    withdrawalCount:'取款次数',
    avgWithdrawal:'人均取款次数',
    avgWithdrawalAmount:'人均取款金额（美元）',
  },
  realTable:{
    realAccount:'交易账户数',
    realCount:'交易次数',
    realHandCount:'交易手数',
    againRealAccount:'人均交易次数',
    againRealHandCount:'人均交易手数',
    dayAvgAccount:'日均交易账户数',
    time:'交易时间',
    productType:'产品类型',
    product:'全部产品',
  },
  realProduction:{
    production:'交易产品',
  },
  device:{
    startTime:'统计开始时间',
    endTime:'统计截止时间',
    type:"行为",
    activation:"激活状态",
    source:"渠道来源",
    medium:"广告媒介",
    series:"广告系列",
    account:"账号",
    enable:"启用",
    landing:"登陆",
    beenActivated:"已激活",
    notActivated:"未激活",
    deviceVendor:"设备厂商占比",
    model:"设备型号占比",
    form:"操作系统占比",
    version:"系统版本占比",
    updateTime:"更新时间",
    vendor:"厂商",
    userCount:"用户数",
    userRatio:"用户占比",
    accessCount:"次数",
    accessRatio:"次数占比",
    deviceModel:"设备型号",
    platform:"操作系统",
    osVersion:"系统版本",
    other:"其他",
    export:"导出",
    systemAnaly:"系统分布统计",
    phoneAnaly:"手机分布统计",
    phoneSystemAnaly:"手机系统版本分布统计",
    appVersionAnaly:"app版本分布统计",
    phoneWifiAnaly:"手机信号分布统计",
    appChannelAnaly:"app渠道分布统计",
    md5:"关联记录",
    networkType:"设备网络信号",
    packageName:"app包名",
    appVerCode:"app版本",
    channel:"渠道",
    recordTime:"操作时间",
    time:"时间",
    recordType:"類型",
    operates:"操作",
    ipAdd:"詳細地址",
    exportFile:"埋点记录",
    faidStr:"設備號",
    androidId:"AndoirdId",
    businessType:"businessType",
    valueOne:"其它信息"
  },
  riskAnalyse: {
    platform: '交易平台',
    accountNo: '交易账号',
    customerNumber: '统一账号',
    activateTime: '激活时间',
    referrerNumber: '直接推荐人',
    firstTimeCashInCurrency: '首次入金货币类型',
    totalCashIn: '总入金数',
    totalCashOut: '总出金数',
    netCashIn: '总净入',
    bonusSent: '赠金送出',
    bonusDeducted: '赠金扣除',
    rewardSent: '奖励送出',
    rewardDeducted: '奖励扣回',
    earnedBonus: '所得赠金',
    totalTrade: '总交易次数',
    totalVolume: '总交易手数',
    totalProfit: '总盈利',
    highProfitMultiple: '高倍盈利（倍）',
    totalClearZero: '总系统清零',
    shortTermTradeRatioPct: '短线交易占比(%)',
    shortTermProfitRatioPct: '短线获利占比(%)',
    top3ProfitableSymbols: '最大盈利三项产品',
    openIp: '开户IP',
    ipUsageCount: 'IP共用统计数',
    sharedCustomerNumbers: 'IP共用账号',
    ipRegLocationCn: 'IP所属地区',
    idRegLocationCn: '身份证所属地区',
    mobilePhoneRegLocationCn: '电话所属地区',
    latestBalance: '最新余额',
    latestEquity: '最新净值',
    latestSettleDate: '最新结算日',
    queryDays: '统计天数',
    thirtyDays: '30天',
    sixtyDays: '60天',
    isSharedIp: '是否筛选共用IP',
    yes: '是',
    no: '否',
    shortTermTradeRatioThreshold: '短线交易比率阈值',
    shortTermProfitRatioThreshold: '短线获利比率阈值',
    ipPlaceholder: '请输入有效的 IPv4 地址',
    thresholdPlaceholder: '支持小数点后 2 位 (例: 0.15)',
    ipError: '开户 IP 格式不正确，请输入有效的 IPv4 地址',
    tradeRatioError: '短线交易比率阈值格式不正确，必须为数字且最多保留 2 位小数',
    profitRatioError: '短线获利比率阈值格式不正确，必须为数字且最多保留 2 位小数',
    customerAccount: '客户账号',
    customerAccountPlaceholder: '请输入客户账号',
    customerAccountError: '客户账号格式错误，请输入有效的整数',
    noRecord: '没有相关记录',
    customerAccountEmpty: '请输入客户账号',
    export: '导出Excel',
    exportMessage: '如果查询数据过多，大约需要10秒以上的等候时间',
    exporting: '正在导出，请稍候...',
    exportFailed: '导出失败',
    exportNetworkError: '导出失败，请确认网络连线',
    customerAccountPlaceholder: '请输入客户账号，多个以逗号分隔',
    customerAccountLimit: '每次最多只能查询 200 个客户账号',
    empty: '无',
    totalCommission: '总佣金',
    totalSwap: '总利息',
    source: '广告来源',
    medium: '媒介',
    customTime: '自定义交易时间',
    threeHundredSixtyFiveDays: '365天',
    shortTermSeconds: '短线交易定义秒数',
    uriTooLong: '查询参数过长，可能导致请求失败，请减少每次查询的账号数量',
  }
}
